module.exports = __webpack_public_path__ + "static/media/erecht24-schwarz-datenschutz-klein.1154cfc8.png";